/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

/**
 * A sequence on this job, with how many of its candidates are enrolled.
 *
 * Unlike the other facets this one is offered at ``count == 0``: a sequence
 * is selectable as soon as it exists on the job, before anyone is enrolled.
 *
 * Every sequence of the job is listed, archived ones included, so the list can
 * be read as "the sequences that exist". That is what lets the panel tell a
 * filter pointing at a deleted sequence — which it drops — from one pointing
 * at an archived sequence, which still means something and is kept. ``archived``
 * is how the picker knows to keep the latter out of the dropdown while still
 * naming it on the chip.
 */
export interface PipelineSequenceFacet {
  sequence_id: string;
  name: string;
  /** @minimum 0 */
  count: number;
  archived?: boolean;
}
